import React from 'react';
import Title from '../../../../@casino/ui/title';
import TableCasino from '../../../../@casino/ui/table';
import { useRouter } from '../../../../@casino/useRouter';
import { setGetListCurrency } from '../store/thunk/setGetListCurrency';
import { useSelector, useDispatch } from 'react-redux';
import { setPutCurrency } from '../store/thunk/setPutCurrency';

const CurrencyList = () => {
    const dispatch = useDispatch();
    const router = useRouter()

    React.useEffect(() => {
        dispatch(setGetListCurrency())
    }, [])

    const list = useSelector(state => state.currency.list);
    const columns = [
        { id: 'currency', label: 'Валюта' },
        { id: 'symbol', label: 'Символ' },
        { id: 'is_active', label: 'Активность' }
    ];
    const rows = list.map((item) => {
        return {
            currency: item.currency,
            symbol: item.symbol,
            is_active: <span onClick={() => dispatch(setPutCurrency({id: item.id}))} style={{cursor: 'pointer', padding: '5px 20px', color: item.is_active ? '#141b33' : '#fff', background: item.is_active ? '#ffc524' : '#FF005C',  borderRadius: 20}}>{item.is_active ? 'Активен' : 'Отключен'}</span>
        }
    })

    return (
        <div style={{padding: '0 20px'}}>
            <Title 
                label="Валюта" 
                labelBtn="Добавить"
                button={() => {
                    router.history.push('/settings/currency/create')
                }}
            />
            <div style={{
                padding: 20, 
                background: '#1b2039', 
                borderRadius: 8, 
                width: 'calc(100% - 40px)', 
            }}>
                <TableCasino
                    columns={columns}
                    rows={rows}
                />
            </div>
        </div>
    )
}

export default CurrencyList;